package com.essntl.features.service.ui.addeditservice.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.features.service.ui.components.ClearAllTagButton
import com.essntl.features.tag.ui.SelectedTagItem
import com.essntl.features.tag.ui.TagDropDownMenu
import com.essntl.uikit.components.button.tinted.EsMediumTintedButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberContains

@OptIn(ExperimentalLayoutApi::class)
@Composable
internal fun TagsSectionItem(
    state: AddEditServiceState,
    onEvent: (AddEditServiceEvent) -> Unit,
    enabled: Boolean,
) {
    var isTagDropdownExpanded by remember {
        mutableStateOf(false)
    }

    val addTag = remember(state.getProfile.data) {
        state.getProfile.data?.role == ProfileModel.Role.Admin ||
            state.getProfile.data?.role == ProfileModel.Role.Supervisor ||
            state.getProfile.data?.role == ProfileModel.Role.Owner
    }

    val selectedTagList = rememberContains(
        state.getAllTag.data.orEmpty(),
        state.service.value.tags,
    ) { tag -> tag.id }

    Spacer(modifier = Modifier.height(2.spacing))
    Box {
        FlowRow(
            horizontalArrangement = Arrangement.spacedBy(1.spacing),
            verticalArrangement = Arrangement.spacedBy(1.spacing),
        ) {
            selectedTagList.forEach { tag ->
                key(tag.id) {
                    SelectedTagItem(
                        tag = tag,
                        onUnselect = {
                            if (!enabled) return@SelectedTagItem

                            val serviceTagIds = state.service.value.tags?.toMutableSet().also {
                                it?.remove(tag.id)
                            }
                            onEvent(
                                AddEditServiceEvent.UpdateServiceFields(
                                    state.service.value.copy(
                                        tags = serviceTagIds.orEmpty(),
                                    ),
                                ),
                            )
                        },
                    )
                }
            }

            if (enabled) {
                EsMediumTintedButton(
                    onClick = {
                        isTagDropdownExpanded = true
                    },
                    text = "Add tag",
                    prefixIconRes = EsIcons.Add,
                )
            }
        }

        TagDropDownMenu(
            expanded = isTagDropdownExpanded,
            onDismissRequest = { isTagDropdownExpanded = false },
            tagList = state.getAllTag.data.orEmpty().sortedBy { it.name.lowercase() },
            selectedTagIds = state.service.value.tags.orEmpty(),
            addTag = addTag,
            onAddTag = { onEvent(AddEditServiceEvent.AddTag(it)) },
            onTagToggle = { tag ->
                val mServiceTagIds = state.service.value.tags.orEmpty().toMutableSet()

                if (!mServiceTagIds.remove(tag.id))
                    mServiceTagIds.add(tag.id)

                onEvent(
                    AddEditServiceEvent.UpdateServiceFields(
                        state.service.value.copy(
                            tags = mServiceTagIds,
                        ),
                    ),
                )
            },
            modifier = Modifier.width(300.dp),
        )
    }

    Spacer(modifier = Modifier.height(.5f.spacing))

    if (enabled &&
        state.service.value.tags.orEmpty().isNotEmpty()
    ) {
        ClearAllTagButton(
            onClick = {
                onEvent(
                    AddEditServiceEvent.UpdateServiceFields(
                        state.service.value.copy(
                            tags = emptySet(),
                        ),
                    ),
                )
            },
            modifier = Modifier
                .fillMaxWidth(),
        )
    }
}
